import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem,
} from '@supplement-bacon/react-toolkit/utils'

const USER_ID_KEY =
  import.meta.env.VITE_LOCAL_STORAGE_USER_ID ?? 'sb-user-data-v1'

const getUserID = () => getLocalStorageItem<number>(USER_ID_KEY)
const setUserID = (id: number) => setLocalStorageItem<number>(USER_ID_KEY, id)
const removeUserID = () => removeLocalStorageItem(USER_ID_KEY)

export { getUserID, setUserID, removeUserID }
